// react
import { Suspense } from 'react';

// tanstack
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/$accountId/_admin/dalux-integration')({
  component: () => (
    <Suspense>
      <Outlet />
    </Suspense>
  ),
  staticData: { crumb: 'dalux-integration:title' },
});
